module.exports = __webpack_public_path__ + "post-listing-block-5-overlay-1rSZNRh.png";